import { apiFetch } from './client';

export interface APIKey {
  id: string;
  userId: string;
  name: string;
  keyPrefix: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface APIKeyCreateResponse extends APIKey {
  key: string; // raw key — shown once only
}

export async function createAPIKey(name: string, expiresAt?: string): Promise<APIKeyCreateResponse> {
  return apiFetch<APIKeyCreateResponse>('/settings/api-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, ...(expiresAt ? { expiresAt } : {}) }),
  });
}

export async function listAPIKeys(): Promise<APIKey[]> {
  return apiFetch<APIKey[]>('/settings/api-keys');
}

export async function revokeAPIKey(id: string): Promise<void> {
  return apiFetch<void>(`/settings/api-keys/${id}`, { method: 'DELETE' });
}
